import React, { CSSProperties, ReactElement } from "react";
import styles from "./Wrapper.module.css";

interface WrapperProps {
  children: ReactElement;
  align?: "left" | "center" | "right";
  maxWidth?: number;
  style?: CSSProperties;
}

const Wrapper: React.FC<WrapperProps> = ({
  children,
  align = "left",
  maxWidth = 1600,
  style,
}): ReactElement => {
  if (style) {
    style.maxWidth = maxWidth;
  }
  return (
    <div style={style || { maxWidth }} className={`${styles.wrapper} ${styles[align]}`}>
      {children}
    </div>
  );
};

export default Wrapper;
